import button from './button'
import colors from './colors'
import gradient from './gradient'
import grid from './grid'
import input from './input'
import margin from './margin'
import modal from './modal'
import polished from './polished'
import select from './select'
import sizes from './sizes'
import slider from './slider'
import tag from './tag'
import typography from './typography'

export default {
  borderRadius: `${sizes.size4}px`,
  sizes: sizes,
  awesomegrid: grid,
  color: {
    ...colors,
    primary: colors.blue500,
    danger: colors.red500,
    success: colors.green500,
    info: colors.celeste500,
    warning: colors.yellow500
  },
  margin: margin,
  typography: typography,
  input: input,
  select: select,
  gradient: gradient,
  modal: modal,
  button: button,
  polished: polished,
  tag: tag,
  slider: slider
}
